import { Quote } from "lucide-react";
import { useApp } from "../context/AppContext";
import { Reveal, SectionHead } from "./Reveal";

export const Testimonials = () => {
  const { t } = useApp();
  return (
    <section id="testimoni" className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-36" data-testid="testimonials-section">
      <SectionHead overline={t.testimonials.overline} title={t.testimonials.title} testId="testimonials-head" />
      <div className="mt-16 grid gap-6 md:mt-20 lg:grid-cols-3">
        {t.testimonials.items.map((item, i) => (
          <Reveal key={item.name} delay={i * 0.08}>
            <figure
              data-testid={`testimonial-${i}`}
              className="flex h-full flex-col rounded-2xl border border-border bg-card p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
            >
              <Quote className="h-8 w-8 text-primary" strokeWidth={1.5} />
              <blockquote className="mt-6 flex-1 font-display text-xl font-medium leading-relaxed tracking-tight">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-8 border-t border-border pt-5">
                <p className="font-bold">{item.name}</p>
                <p className="text-sm text-muted-foreground">{item.role}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
